<!-- <casi-tile-titlebar [title]="title" [showAdd]="showAdd"></casi-tile-titlebar> -->
<link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" />

<!-- <kendo-window [draggable]="isDraggable" (close)="openClose(false)" [(state)]="windowState" title="My Work">
  @if (isDraggable && windowState !== 'maximized') {
  <p style="text-align: center;">I can be moved!</p>
  } @if (!isDraggable || windowState === 'maximized') {
  <p style="text-align: center;">I cannot be moved!</p>
  }
  <p>my-work works!</p>
</kendo-window> -->
<p>{{tile | json}}</p>
<kendo-card>
  <kendo-card-actions [orientation]="actionsOrientation" [layout]="actionsLayout">
    <button kendoButton fillMode="flat" (click)="toggleLike()">
      <span [ngClass]="heartIcon()"></span>
      Like
    </button>
    <hr kendoCardSeparator orientation="vertical" *ngIf="horizontalStretched" />
    <button kendoButton fillMode="flat" themeColor="primary" (click)="toggleRecipe()">
      <span class="k-icon k-font-icon k-i-more-vertical"></span>
      {{ btnText }}
    </button>
  </kendo-card-actions>
  <kendo-label>Wally Rules</kendo-label>
  <kendo-card-body>
    <h4>Pumpkin Waffles</h4>
    <div *ngIf="expanded">
      <hr kendoCardSeparator />
      <div class="recipe-wrap">
        Mix together flour, baking powder, salt, cinnamon, nutmeg, ginger,
        and cloves in a large bowl. In a second bowl, add egg yolks,
        sugar, pumpkin, milk, and oil; Whip the egg until stiff peaks
        form. Gently fold in the flour mixture followed by the whipped egg
        whites. Cook according to your waffle iron directions. Serve with
        butter and maple syrup.
      </div>
    </div>
  </kendo-card-body>
  <hr kendoCardSeparator *ngIf="horizontalStretched" />
</kendo-card>

<div class="example-config">
  <div>Actions Orientation</div>
  <label class="k-radio-label" for="horizontal">
    <input kendoRadioButton type="radio" id="horizontal" value="horizontal" name="actionsOrientation"
      [(ngModel)]="actionsOrientation" />
    Horizontal
  </label>

  <label class="k-radio-label" for="vertical">
    <input kendoRadioButton type="radio" id="vertical" value="vertical" name="actionsOrientation"
      [(ngModel)]="actionsOrientation" />
    Vertical
  </label>
  <hr />

  <div>Actions Layout</div>
  <label class="k-radio-label" for="start">
    <input kendoRadioButton type="radio" id="start" value="start" name="actionsLayout" [(ngModel)]="actionsLayout" />
    Start
  </label>

  <label class="k-radio-label" for="end">
    <input kendoRadioButton type="radio" id="end" value="end" name="actionsLayout" [(ngModel)]="actionsLayout" />
    End
  </label>

  <label class="k-radio-label" for="stretched">
    <input kendoRadioButton type="radio" id="stretched" value="stretched" name="actionsLayout"
      [(ngModel)]="actionsLayout" />
    Stretched
  </label>

  <label class="k-radio-label" for="center">
    <input kendoRadioButton type="radio" id="center" value="center" name="actionsLayout" [(ngModel)]="actionsLayout" />
    Center
  </label>
</div>
